<mat-toolbar style="background: linear-gradient(135deg, #1C593D 0%, #166534 50%, #14532d 100%); color: white; height: 64px; padding: 0 16px; box-shadow: 0 2px 8px rgba(0,0,0,0.15);">
  <button type="button" (click)="sidenav.toggle()" title="Menu"
    style="display: inline-flex; align-items: center; justify-content: center; width: 40px; height: 40px; background: rgba(255,255,255,0.08); border: 1px solid rgba(255,255,255,0.12); border-radius: 10px; cursor: pointer; color: white; transition: all 0.2s ease;"
    onmouseover="this.style.background='rgba(255,255,255,0.18)';this.style.borderColor='rgba(255,255,255,0.25)'" onmouseout="this.style.background='rgba(255,255,255,0.08)';this.style.borderColor='rgba(255,255,255,0.12)'">
    <mat-icon>menu</mat-icon>
  </button>
  <div style="display: flex; align-items: center; margin-left: 12px; cursor: pointer;" routerLink="/retail/home">
    <div style="background: rgba(255,255,255,0.12); border-radius: 12px; padding: 6px; display: flex; align-items: center; justify-content: center;">
      <img style="width: 32px; height: auto; filter: brightness(0) invert(1);" src="assets/img/LogoAW2025.png">
    </div>
    <span class="hidden sm:inline" style="margin-left: 10px; font-weight: 700; font-size: 1.05rem; letter-spacing: 0.3px; color: white;">Aguacate <span style="font-weight: 400; opacity: 0.85;">Retail</span></span>
  </div>
  <span class="toolbar-item-spacer"></span>
  <div class="flex flex-col items-end mr-3">
    <p style="margin: 0; font-size: 0.72rem; font-weight: 500; color: rgba(255,255,255,0.65); line-height: 1.2;">Bienvenido</p>
    <span style="font-size: 0.85rem; font-weight: 600; color: white; line-height: 1.3;">{{userName}}</span>
  </div>
  <button type="button" [matMenuTriggerFor]="userAccountMenu" title="Mi Cuenta"
    style="display: inline-flex; align-items: center; justify-content: center; width: 40px; height: 40px; background: rgba(255,255,255,0.08); border: 1px solid rgba(255,255,255,0.12); border-radius: 10px; cursor: pointer; color: white; transition: all 0.2s ease;"
    onmouseover="this.style.background='rgba(255,255,255,0.18)';this.style.borderColor='rgba(255,255,255,0.25)'" onmouseout="this.style.background='rgba(255,255,255,0.08)';this.style.borderColor='rgba(255,255,255,0.12)'">
    <mat-icon>account_circle</mat-icon>
  </button>
  <mat-menu #userAccountMenu [overlapTrigger]="false" yPosition="below" class="profile-menu">
    <div style="padding: 12px 16px 8px; border-bottom: 1px solid #e5e7eb;">
      <p style="margin: 0; font-size: 0.7rem; color: #9ca3af; font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px;">Mi cuenta</p>
      <p style="margin: 2px 0 0; font-size: 0.85rem; color: #1C593D; font-weight: 700;">{{userName}}</p>
    </div>
    <button mat-menu-item routerLink="client/user-profile" [disabled]="!isEnabledUser"
      *ngIf="userRole === rolesEnum.aguacate_client" class="profile-menu-item">
      <mat-icon style="color: #1C593D;">person</mat-icon>
      <span>Mi perfil</span>
    </button>
    <div style="padding: 4px 8px;">
      <button mat-menu-item (click)="signOut()" class="profile-menu-logout">
        <mat-icon style="color: #dc2626;">logout</mat-icon>
        <span>Cerrar sesión</span>
      </button>
    </div>
  </mat-menu>
</mat-toolbar>

<mat-sidenav-container class="app-container">
  <mat-sidenav #sidenav mode="push" opened="false" [class.mat-elevation-z4]="true" class="app-sidenav">
    <!-- Sidenav Header -->
    <div class="sidenav-header">
      <div class="sidenav-logo-container">
        <img src="assets/img/LogoAW2025.png" style="width: 36px; height: auto;">
      </div>
      <div>
        <span class="sidenav-brand">Aguacate</span>
        <span class="sidenav-brand-light">Retail</span>
      </div>
    </div>

    <mat-nav-list class="sidenav-list">
      <mat-list-item routerLink="/retail/home" class="menu-element" (click)="closeSidenav(sidenav)">
        <span class="menu-item-content">
          <mat-icon class="menu-icon">home</mat-icon>
          <span>Inicio</span>
        </span>
      </mat-list-item>

      <!-- Menu usuario -->
      <ng-container *ngIf="userRole=== rolesEnum.aguacate_retail_client">
        <mat-list-item routerLink="/retail/recipients" class="menu-element" (click)="closeSidenav(sidenav)">
          <span class="menu-item-content">
            <mat-icon class="menu-icon">assignment_ind</mat-icon>
            <span>Beneficiarios Fiat</span>
          </span>
        </mat-list-item>
      </ng-container>

      <!-- Menu operario -->
      <ng-container *ngIf="userRole=== rolesEnum.aguacate_retail_cashier">
        <div class="menu-section-label">Operaciones</div>

        <mat-list-item routerLink="/retail/transaction-cashier" class="menu-element" (click)="closeSidenav(sidenav)">
          <span class="menu-item-content">
            <mat-icon class="menu-icon">payments</mat-icon>
            <span>Abonos/Débitos</span>
          </span>
        </mat-list-item>
        <mat-list-item routerLink="/retail/balance-cajero" class="menu-element" (click)="closeSidenav(sidenav)">
          <span class="menu-item-content">
            <mat-icon class="menu-icon">account_balance_wallet</mat-icon>
            <span>Balance cajero</span>
          </span>
        </mat-list-item>
        <mat-list-item routerLink="/retail/cash-closing-report" class="menu-element" (click)="closeSidenav(sidenav)">
          <span class="menu-item-content">
            <mat-icon class="menu-icon">price_check</mat-icon>
            <span>Reporte cierre de caja</span>
          </span>
        </mat-list-item>
        <mat-list-item routerLink="/retail/user-balance" class="menu-element" (click)="closeSidenav(sidenav)">
          <span class="menu-item-content">
            <mat-icon class="menu-icon">swap_horiz</mat-icon>
            <span>Movimientos de usuarios</span>
          </span>
        </mat-list-item>
        <mat-list-item routerLink="/retail/status-cajero" class="menu-element" (click)="closeSidenav(sidenav)">
          <span class="menu-item-content">
            <mat-icon class="menu-icon">request_quote</mat-icon>
            <span>Estatus cajero</span>
          </span>
        </mat-list-item>

        <div class="menu-section-label">Usuarios</div>

        <mat-list-item routerLink="/retail/new-user" class="menu-element" (click)="closeSidenav(sidenav)">
          <span class="menu-item-content">
            <mat-icon class="menu-icon">person_add</mat-icon>
            <span>Crear Usuario</span>
          </span>
        </mat-list-item>
        <mat-list-item routerLink="/retail/compliance" class="menu-element" (click)="closeSidenav(sidenav)">
          <span class="menu-item-content">
            <mat-icon class="menu-icon">verified_user</mat-icon>
            <span>Compliance</span>
          </span>
        </mat-list-item>

        <div class="menu-section-label">Transacciones</div>

        <mat-expansion-panel [class.mat-elevation-z0]="true" class="menu-expansion">
          <mat-expansion-panel-header>
            <mat-icon class="menu-icon">currency_exchange</mat-icon>
            <span>Transacciones VES</span>
          </mat-expansion-panel-header>
          <mat-nav-list>
            <mat-list-item routerLink="/retail/transactions" class="menu-element" (click)="closeSidenav(sidenav)">
              <span class="menu-item-content">
                <mat-icon class="menu-icon">list_alt</mat-icon>
                <span>Lista de transacciones VES</span>
              </span>
            </mat-list-item>
            <mat-list-item [routerLink]="['/retail/pending-transactions-binance']"
              [queryParams]="{ bankType: 'BINANCE'}" class="menu-element" (click)="closeSidenav(sidenav)">
              <span class="menu-item-content">
                <mat-icon class="menu-icon">currency_bitcoin</mat-icon>
                <span>Pendientes Binance</span>
              </span>
            </mat-list-item>
            <mat-list-item routerLink="/retail/pending-transactions" class="menu-element" (click)="closeSidenav(sidenav)">
              <span class="menu-item-content">
                <mat-icon class="menu-icon">hourglass_top</mat-icon>
                <span>Transacciones pendientes</span>
              </span>
            </mat-list-item>
            <mat-list-item routerLink="/retail/completed-ves-transactions" class="menu-element" (click)="closeSidenav(sidenav)">
              <span class="menu-item-content">
                <mat-icon class="menu-icon">check_circle</mat-icon>
                <span>Transacciones VES completadas</span>
              </span>
            </mat-list-item>
            <mat-list-item routerLink="/retail/crixto" class="menu-element" (click)="closeSidenav(sidenav)">
              <span class="menu-item-content">
                <mat-icon class="menu-icon">credit_card</mat-icon>
                <span>Transacciones Crixto</span>
              </span>
            </mat-list-item>
            <mat-list-item routerLink="/retail/cbpay" class="menu-element" (click)="closeSidenav(sidenav)">
              <span class="menu-item-content">
                <mat-icon class="menu-icon">credit_card</mat-icon>
                <span>Transacciones CBPay</span>
              </span>
            </mat-list-item>
          </mat-nav-list>
        </mat-expansion-panel>

        <div class="menu-section-label">Cuentas</div>

        <mat-list-item routerLink="working-accounts" class="menu-element" (click)="closeSidenav(sidenav)">
          <span class="menu-item-content">
            <mat-icon class="menu-icon">work</mat-icon>
            <span>Cuentas de trabajo</span>
          </span>
        </mat-list-item>

        <mat-expansion-panel [class.mat-elevation-z0]="true" class="menu-expansion">
          <mat-expansion-panel-header>
            <mat-icon class="menu-icon">settings</mat-icon>
            <span>Configuración</span>
          </mat-expansion-panel-header>
          <mat-nav-list>
            <mat-list-item routerLink="/retail/rates" class="menu-element" (click)="closeSidenav(sidenav)">
              <span class="menu-item-content">
                <mat-icon class="menu-icon">tune</mat-icon>
                <span>Parámetros tasa bolívares</span>
              </span>
            </mat-list-item>
            <mat-list-item routerLink="/retail/operation-hours" class="menu-element" (click)="closeSidenav(sidenav)">
              <span class="menu-item-content">
                <mat-icon class="menu-icon">schedule</mat-icon>
                <span>Horarios de operación</span>
              </span>
            </mat-list-item>
          </mat-nav-list>
        </mat-expansion-panel>
      </ng-container>
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content class="sidenav-content">
    <div class="app-sidenav-content">
      <router-outlet></router-outlet>
      <div class="fab-container" *ngIf="userRole=== rolesEnum.aguacate_retail_client">
        <button type="button" (click)="redirectToExternalLink()" title="WhatsApp"
          style="display: inline-flex; align-items: center; justify-content: center; width: 56px; height: 56px; background: #1C593D; color: white; border: none; border-radius: 50%; cursor: pointer; box-shadow: 0 4px 12px rgba(0,0,0,0.25); transition: all 0.2s ease;"
          onmouseover="this.style.background='#059669';this.style.transform='scale(1.08)'" onmouseout="this.style.background='#1C593D';this.style.transform='scale(1)'">
          <mat-icon>contact_support</mat-icon>
        </button>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
